// extracted by mini-css-extract-plugin
module.exports = {"promotionBookmark":"_3Mru7Pe85gFWPAYGpJoKeh"};